export const getOrderLineBadgeColor = status => {
  switch (status) {
    case 'created':
      return 'secondary';

    case 'processing':
      return 'primary';

    case 'completed':
      return 'info';

    case 'cancelled':
      return 'danger';

    default:
      return 'secondary';
  }
};

export const getOrderBadgeColor = status => {
  switch (status) {
    case 'created':
      return 'secondary';

    case 'processing':
      return 'primary';

    case 'completed':
      return 'info';

    case 'unfulfillable':
    case 'cancelled':
      return 'danger';

    default:
      return 'secondary';
  }
};
